export default function Switch(theme) {
    return {
        MuiSwitch: {
            styleOverrides: {
                thumb: {
                    boxShadow: 'none'
                },
                track: {
                    opacity: 1,
                    backgroundColor: theme.palette.grey[500]
                },
                switchBase: {
                    left: 0,
                    right: 'auto',
                    color: theme.palette.background[300],
                    '&:not(:.Mui-checked)': {
                        color: theme.palette.grey[100],
                        ...theme.applyStyles('dark', {
                            color: theme.palette.grey[300]
                        })
                    },
                    '&.Mui-checked.Mui-disabled, &.Mui-disabled': {
                        color: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            color: theme.palette.grey[600]
                        })
                    },
                    '&.Mui-disabled+.MuiSwitch-track': {
                        opacity: 1,
                        backgroundColor: theme.palette.action.disabledBackground
                    }
                }
            }
        }
    };
}
